module.exports = __webpack_public_path__ + "img/complete.c2a39ae5.svg";